import React from 'react'
import '../App.css';
import { Navbar, Bibliote, Footer} from '../container';
// import Biblioteca from '../container/biblio/biblioteca/Biblioteca';

const SecBibliote = () => {
  return (
    <div className="App_DB Libreria ">
        <Navbar/> 
        {/* <Biblioteca/> */}
        <Bibliote/>
        <Footer/>

        {/* <NL_Header/>
        <NL_Adn40/>
        <NL_Video_semblanza/>
        <NL_Recomendados/>
        <NL_Descarga/> */}
    </div>
  )
}

export default SecBibliote
